var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "demo-block",
    class: [{
      opened: _vm.show
    }, _vm.clz]
  }, [_c('div', {
    staticClass: "preview bd-example"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._t("desp"), _vm._v(" "), _c('svg', {
    staticClass: "icon-toggle-code",
    attrs: {
      "viewBox": "0 0 1024 1024",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    },
    on: {
      "click": function($event) {
        _vm.show = !_vm.show
      }
    }
  }, [_c('path', {
    attrs: {
      "fill": "#a8a8a8",
      "d": "M236.2 311.5 236.2 311.5c-12.5-12.5-32.8-12.5-45.3 0L9.4 493c-12.5 12.5-12.5 32.7 0 45.2l181.6 182c12.5 12.5 32.8 12.5 45.3 0l0 0c12.5-12.5 12.5-32.8 0-45.3L77.1 515.9l159.2-159.2C248.7 344.2 248.7 323.9 236.2 311.5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#a8a8a8",
      "d": "M787.8 311.5 787.8 311.5c12.5-12.5 32.8-12.5 45.3 0L1014.6 493c12.5 12.5 12.5 32.7 0 45.2L833 720.3c-12.5 12.5-32.8 12.5-45.3 0l0 0c-12.5-12.5-12.5-32.8 0-45.3l159.2-159.2L787.8 356.7C775.3 344.2 775.3 323.9 787.8 311.5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#a8a8a8",
      "d": "M691.2 132.1 691.2 132.1c15.6 8.2 21.6 27.6 13.4 43.2L333.5 879.2c-8.2 15.6-27.6 21.6-43.2 13.4l0 0c-15.6-8.2-21.6-27.6-13.4-43.2l371.1-703.9C656.2 129.9 675.5 123.9 691.2 132.1z"
    }
  })])], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "source"
  }, [_c('span', {
    ref: "copy",
    staticClass: "btn-clipboard",
    attrs: {
      "data-original-title": "Copy to clipboard"
    }
  }, [_vm._v("Copy")]), _vm._v(" "), _vm._t("source")], 2)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a156c51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./example/components/Demo.vue
// module id = 200
// module chunks = 19